import React, {useState} from 'react'
import {Box} from '@mui/material'
import TabBar from 'src/components-new/layout/TabBar'
import UsefulMaterialsTab from './UsefulMaterialsTab'
import UsefulLinksTab from './UsefulLinksTab'

type TabKey = 'materials' | 'links'

const TABS = [
  {key: 'materials', label: 'Materiali utili'},
  {key: 'links', label: 'Link utili'},
]

export default function InfoMaterialsNew(): JSX.Element {
  const [activeTab, setActiveTab] = useState<TabKey>('materials')

  return (
    <Box>
      <Box sx={{borderBottom: '1px solid', borderColor: 'divider', mb: 3}}>
        <TabBar
          tabs={TABS}
          activeKey={activeTab}
          onChange={(key) => setActiveTab(key as TabKey)}
        />
      </Box>

      {activeTab === 'materials' ? <UsefulMaterialsTab /> : <UsefulLinksTab />}
    </Box>
  )
}
